import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
} from "@mui/material";
import useWindowSize from "hooks/useWindowSize";
import { FC, useEffect, useState } from "react";
import { H3, H5 } from "components/Typography";
import { useCart } from "hooks/use-cart";
import CompatibleMotherboardCarousel from "components/products/CompatibleMotherboardCarousel";

// =============================================================
type Props = {
  visible: boolean;
  onCloseProps: () => void;
};
// =============================================================

// The data should be from checkout.
const CompatibleMotherboardsDialog: FC<Props> = ({ visible, onCloseProps }) => {
  const width = useWindowSize();
  const { cpusThatNeedsMotherboardAsBundle } = useCart();

  const [visibleSlides, setVisibleSlides] = useState(4);

  useEffect(() => {
    if (width < 500) setVisibleSlides(1);
    else if (width < 650) setVisibleSlides(2);
    else setVisibleSlides(3);
  }, [width]);

  return (
    <Dialog open={visible} fullWidth={false} maxWidth="xl">
      <DialogTitle>
        <H3>
          It looks like you are trying to checkout a CPU that is strictly for
          bundle.
        </H3>
        <H5>To continue, please select compatible motherboard(s).</H5>
      </DialogTitle>
      <DialogContent>
        {cpusThatNeedsMotherboardAsBundle?.map((datum, i) => (
          <Box key={`${datum?.cpuProductName}${i}`} sx={{ padding: 2 }}>
            <CompatibleMotherboardCarousel
              isForDialog
              withBundle={1}
              cpuProductName={datum?.cpuProductName}
              compatibleMotherboards={datum?.motherboards}
            />
            <Divider />
          </Box>
        ))}
      </DialogContent>
      <DialogActions>
        <Button
          fullWidth
          autoFocus
          color="error"
          variant="contained"
          onClick={onCloseProps}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CompatibleMotherboardsDialog;
